/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@repo/ui";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import {
  useLookupCategories,
  useLookupCustomers,
  useLookupSubCategories,
  useLookupGetAllVans,
  useLookupOffices,
  useLookupBusinessUnit,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import { useGetAllUsers, useGetUserByRoles } from "services/auth";
import Loader from "ui/page-loader";
import { Label } from "ui/label";

import {
  CREATION_CHANNELS,
  emptyTicket,
  PRIORITIES_LIST,
  TOGGLE,
} from "../constants";
import {
  useCreatePanicAlertIncidentTicket,
  useDeletePanicAlertAttachment,
  useGetPanicAlertIncidentTicketDetails,
  useSavePanicAlertIncidentTicket,
  useSubmitPanicAlertIncidentTicket,
} from "services/panic-alert";
import { TicketCreateHeader } from "components/tickets/ticket-create-header";
import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";
import { useGetImageURL } from "services/common";
import { Trash } from "lucide-react";
import { useGetPanicAlertTasks } from "services/tickets";
import { getLocalISODateString } from "utils/date-utils";

export default function CreatePanicAlertIncidentTicket() {
  const defaultPanicAlertTicket = {
    ...emptyTicket,
    activityType: "Panic Alert Incident",
    customer: "Transguard Group (TG)",
    assignmentGroup: "Cash Security Monitoring Team",
    attachments: [],
    totalConnectTimeWithTeam: `00:00:00`,
    emailTime: new Date(),
    timeOfAlarm: new Date(),
    timeOfContactWithTeam: new Date(),
    vehicleTeamLeftTime: new Date(),
    vehicleIdleTime: `00:00:00`,
  };

  const Locations = [
    { text: "DXB Operation Office", value: "DXB Operation Office" },
    { text: "NE Operation Office", value: "NE Operation Office" },
    { text: "AUH Operation Office", value: "AUH Operation Office" },
    { text: "Al Ain Operation Office", value: "Al Ain Operation Office" },
  ];

  const Area = [
    { text: "Dubai", value: "Dubai" },
    { text: "Sharjah", value: "Sharjah" },
    { text: "Ajman", value: "Ajman" },
    { text: "Umm Al Quwain", value: "Umm Al Quwain" },
    { text: "Ras Al Khaimah", value: "Ras Al Khaimah" },
    { text: "Fujairah", value: "Fujairah" },
    { text: "Abu Dhabi", value: "Abu Dhabi" },
    { text: "Al Ain", value: "Al Ain" },
  ];

  const Region = [
    { text: "Dubai", value: "Dubai" },
    { text: "Northern Region", value: "Northern Region" },
    { text: "Abu Dhabi", value: "Abu Dhabi" },
    { text: "Al Ain", value: "Al Ain" },
  ];
  const [ticketDetails, setTicketDetails] = useState({
    ...defaultPanicAlertTicket,
  });
  const [imagePreview, setImagePreview] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const {
    mutate: getDrivers,
    data: driverList,
    isPending: gettingDrivers,
  } = useGetUserByRoles();
  const {
    mutate: getGuards,
    data: guardList,
    isPending: gettingGuards,
  } = useGetUserByRoles();
  const {
    mutate: getUsers,
    data: usersListRes,
    isPending: gettingUsers,
  } = useGetUserByRoles();

  const {
    mutate: getBusinessUnits,
    data: businessUnitRes,
    isPending: gettingBusinessUnit,
  } = useLookupBusinessUnit();
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getVans,
    data: vansListRes,
    isPending: gettingVans,
  } = useLookupGetAllVans();
  const {
    mutateAsync: getOffices,
    data: officesListRes,
    isPending: gettingOffices,
    reset: resetOffices,
  } = useLookupOffices();

  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useCreatePanicAlertIncidentTicket();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSavePanicAlertIncidentTicket();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
  } = useSubmitPanicAlertIncidentTicket();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetPanicAlertTasks();
  const { mutate: deleteAttachment } = useDeletePanicAlertAttachment();

  const { mutateAsync: getImageURL } = useGetImageURL();
  const form = useForm({
    mode: "onSubmit",
    shouldUnregister: false,
    defaultValues: { ...defaultPanicAlertTicket },
  });

  useEffect(() => {
    form.register("incidentLocation", {
      required: "Please enter Incident Location",
    });
  }, [form]);
  useEffect(() => {
    onActivityTypeChange(defaultPanicAlertTicket.activityType);
    getVans();
    getCustomersList();
    getBusinessUnits();

    getDrivers(["Driver"]);
    getGuards(["Guard"]);
    getUsers([
      "Driver",
      "Guard",
      "Team Leader",
      "SLM engineer",
      "Site Inspector",
    ]);
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  useEffect(() => {
    if (ticketDetailsRes && customersListRes && vansListRes) {
      const _details = ticketDetailsRes.data[0];
      const currentCustomer = customersListRes.data.find(
        (elm) => elm.customerId === _details.customerId
      );
      const _ticket = {
        ..._details,
        isIncidentReport: _details.isIncidentReport ? "Yes" : "No",
        isWorkOrder: _details.isWorkOrder ? "Yes" : "No",
        customer: currentCustomer?.name || "",
        reportedBy: _details.reportedBy,
        attachments: [],
        priority: PRIORITIES_LIST.find((elm) => elm.value === _details.priority)
          .id,
        emailTime: _details.emailTime
          ? new Date(moment(_details.emailTime))
          : null,
        timeOfAlarm: _details.timeOfAlarm
          ? new Date(moment(_details.timeOfAlarm))
          : null,
        timeOfContactWithTeam: _details.timeOfContactWithTeam
          ? new Date(moment(_details.timeOfContactWithTeam))
          : null,
        vehicleTeamLeftTime: _details.vehicleTeamLeftTime
          ? new Date(moment(_details.vehicleTeamLeftTime))
          : null,
      };
      const getImages = async () => {
        return Promise.all(
          _details.uploadedFiles.map(async (file) => ({
            ...file,
            filePath: await getImageURL(file.filePath),
          }))
        );
      };
      // usage
      (async () => {
        const images = await getImages();
        setUploadedImages(images);
        // full array with resolved filePath URLs
      })();
      form.reset({ ..._ticket });
      setTicketDetails({ ..._details });
      onAssetChange(_details.assetId);
      resetDetailsApi();
      if (_details.category) {
        getSubCategories({
          activityType: _details.activityType,
          category: _details.category,
        });
      }
    }
    if (createTicketRes || submitTicketRes || saveTicketRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (saveTicketRes) {
      if (saveTicketRes.status && saveTicketRes.status === 200) {
        sweetAlert({
          title: "Operation Successful!",
          text: "Ticket Has Been Saved",
          icon: "success",
        });
        resetSaveTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset();
      }
    }
    if (saveTicketError) {
      resetSaveTicket();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    vansListRes,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    customerId: { required: "Please Enter Value" },
    assetId: { required: "Please Enter Value" },
    customerTicketNo: { required: "Please Enter Value" },
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    assigneeId: { required: "Please Enter Value" },
    billingCharges: { required: "Please Enter Value" },
    correlationId: { required: "Please Enter Value" },
    slmEngineer: { required: "Please Enter Value" },
    creationChannel: { required: "Please Enter Value" },
    reportedBy: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
    location: { required: "Please Select Value" },
    area: { required: "Please Select Value" },
    region: { required: "Please select Region" },
    incidentLocation: { required: "Please enter Incident Location" },
  };

  const createTicketPayload = () => {
    const data = form.getValues();

    const customerId =
      data?.customerId ||
      customersListRes?.data.find((elm) => elm.name === data.customer)
        ?.customerId;

    const currentOffice = officesListRes?.data.find(
      (elm) => elm.officeId === data.officeId
    );

    // Helper function to find user info by ID
    const getUserInfo = (id) =>
      usersListRes?.data?.find((user) => user.id === id) || {};

    // Get selected users
    const ctlUser = getUserInfo(data.ctlUserId);
    const custodianUser = getUserInfo(data.custodianUserId);
    const driverUser = getUserInfo(data.driverUserId);
    const guardUser = getUserInfo(data.guardUserId);

    const payload = {
      cashCenterId: data.cashCenterId,
      customerId: customerId || "",
      customerName: data.customer || "",
      assetId: data.assetId,
      assetName: data.assetReferenceNumber,
      region: data.region || "",
      officeId: data.officeId,
      officeName: currentOffice?.officeName || "",
      location: data.location,
      area: data.area || "",
      creationChannel: "Web",
      assetReferenceNumber: data.assetReferenceNumber,
      assignmentGroup: "Cash Security Monitoring Team",
      activityType: "Panic Alert Incident",
      category: data.category,
      subCategory: data.subCategory,
      isVaultAccessRequired: false,
      tgImsIncidentNo: data.tgimsNumber || "",
      priority: data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === data.priority)[0].value
        : "",
      isChargeable: false,
      remarks: data.remarks || "",
      totalConnectTimeWithTeam: data.totalConnectTimeWithTeam,
      violationType: data.violationType || undefined,
      sicknessType: data.sicknessType || undefined,
      incidentLocation: data.incidentLocation || undefined,
      isIncidentReport: data.isIncidentReport === "Yes",
      businessUnitId: data.businessUnitId || undefined,
      isWorkOrder: data.isWorkOrder === "Yes",
      driverUserId: data.driverUserId || undefined,
      guardUserId: data.guardUserId || undefined,
      ctlUserId: data.ctlUserId || undefined,
      custodianUserId: data.custodianUserId || undefined,
      violatorUserId: data.violatorUserId || undefined,
      sickStaffUserId: data.sickStaffUserId || undefined,
      reportedBy: data.reportedBy || undefined,
      auditedByUserId: data.auditedByUserId || undefined,
      assignedToUserId: data.assignedToUserId || undefined,
      emailTime: data.emailTime
        ? getLocalISODateString(data.emailTime)
        : undefined,
      timeOfAlarm: data.timeOfAlarm
        ? getLocalISODateString(data.timeOfAlarm)
        : undefined,
      timeOfContactWithTeam: data.timeOfContactWithTeam
        ? getLocalISODateString(data.timeOfContactWithTeam)
        : undefined,
      vehicleTeamLeftTime: data.vehicleTeamLeftTime
        ? getLocalISODateString(data.vehicleTeamLeftTime)
        : undefined,
      vehicleIdleTime: data.vehicleIdleTime || undefined,
      attachments: data?.attachments || [],

      regulatoryStickerNo: data.regulatoryStickerNo || "",

      ctlTgId: ctlUser?.employeeId || "",
      ctlName: ctlUser?.name || "",
      ctlContact: ctlUser?.mobileNo || "",

      custodianTgId: custodianUser?.employeeId || "",
      custodianName: custodianUser?.name || "",
      custodianContact: custodianUser?.mobileNo || "",

      driverTgId: driverUser?.employeeId || "",
      driverName: driverUser?.name || "",
      driverContact: driverUser?.mobileNo || "",

      guardTgId: guardUser?.employeeId || "",
      guardName: guardUser?.name || "",
      guardContact: guardUser?.mobileNo || "",
    };

    return payload;
  };

  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      ...createTicketPayload(),
    };
    submitTicket({ ...payload });
  };

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    createTicket(createTicketPayload());
  };

  const onSaveAsDraft = () => {
    saveTicket({ ...createTicketPayload() });
  };

  const onAssetChange = (data) => {
    resetOffices();
    form.setValue("officeId", "");
    const currentVehicle = vansListRes?.data.find((elm) => elm.id === data);
    if (currentVehicle) {
      form.setValue("officeId", currentVehicle.officeId);
      getOffices(currentVehicle.cashCenterId);
      form.setValue("cashCenterId", currentVehicle.cashCenterId);
      form.setValue("assetReferenceNumber", currentVehicle.registrationNo);
    }
  };

  const onActivityTypeChange = (data) => {
    form.setValue("category", "");
    form.setValue("subCategory", "");
    getCategories(data);
  };
  const onCategoryChange = (data) => {
    form.setValue("subCategory", "");
    form.setValue("vaultAccessRequired", "No");
    getSubCategories({
      activityType: form.getValues("activityType"),
      category: data,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const attachments = form.getValues("attachments");
      reader.onload = (e) => {
        const base64DataUrl = e.target.result;
        const base64String = base64DataUrl.split(",")[1]; // remove data:image/...;base64,

        const fileObject = {
          fileName: file.name,
          contentType: file.type,
          contents: base64String,
        };

        setImagePreview([...imagePreview, base64DataUrl]);

        form.setValue("attachments", [...attachments, fileObject]);
        // For JSON
      };

      reader.readAsDataURL(file); // read file as base64
    }
  };

  return (
    <>
      {gettingCustomersList ||
      gettingDrivers ||
      gettingGuards ||
      gettingUsers ||
      savingTicket ||
      creatingTicket ||
      gettingBusinessUnit ||
      gettingOffices ||
      gettingCategories ||
      gettingVans ||
      gettingTicket ||
      submittingTicket ||
      gettingSubCategories ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <TicketCreateHeader
          canUpload
          isDraft={form.watch("status") === "Draft"}
          onSaveAsDraft={form.handleSubmit(onSaveAsDraft)}
          onSubmit={form.handleSubmit(onSubmit)}
          onSave={form.handleSubmit(onSave)}
          handleFileChange={handleFileChange}
          onReset={onReset}
          onCancel={oncancel}
        />
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Panic Alert Incident</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="reportedBy"
                    label="Reported By"
                    inputProps={{ autoFocus: true }}
                    // rules={verificationRules.reportedBy}
                  />
                  <FormInput
                    {...generalProps}
                    name="tgimsNumber"
                    label="TGIMS Number"
                    placeholder="Enter TGIMS Number"
                  />
                  <FormInput
                    {...generalProps}
                    label="Account"
                    name="customer"
                    inputProps={{ readOnly: true }}
                  />
                  <FormSelect
                    {...generalProps}
                    // isRequired={true}
                    name="priority"
                    label="Priority"
                    placeholder="Select Priority"
                    data={PRIORITIES_LIST}
                    id="id"
                    text="text"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Asset ID"
                    name="assetId"
                    isRequired
                    placeholder="Select Asset"
                    // disabled={!form.watch("customerId")}
                    data={
                      vansListRes?.data.map((elm) => ({
                        ...elm,
                        name: `${elm.registrationNo}-${elm.fleetNo}`,
                      })) || []
                    }
                    text="name"
                    id="id"
                    rules={verificationRules.assetId}
                    onChange={onAssetChange}
                    recordContentClass="max-w-[1000px]"
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="creationChannel"
                    label="Creation Channel"
                    placeholder="Select Creation Channel"
                    data={CREATION_CHANNELS}
                    id="id"
                    text="text"
                    rules={verificationRules.creationChannel}
                  />
                  <FormInput
                    {...generalProps}
                    label="Activity Type"
                    name="activityType"
                    inputProps={{ readOnly: "true" }}
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="region"
                    label="Region"
                    placeholder="Select Region"
                    data={Region}
                    text="text"
                    id="value"
                    rules={verificationRules.region}
                    // inputProps={{
                    //   onChange: (e) => form.setValue("region", e.target.value),
                    // }}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Category"
                    name="category"
                    isRequired
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                    info={
                      form.watch("activityType")
                        ? ""
                        : "Select Activity Type To Load Data"
                    }
                  />

                  <FormDropdown
                    {...generalProps}
                    name="location"
                    label="Location"
                    isRequired
                    placeholder="Select Location"
                    data={Locations?.map((elm) => ({
                      ...elm,
                      location: elm.text,
                    }))}
                    text="location"
                    id="location"
                    rules={verificationRules.location}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sub Category"
                    name="subCategory"
                    isRequired
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    info={
                      form.watch("activityType") && form.watch("category")
                        ? ""
                        : "Select Activity Type & Category To Load Data"
                    }
                    onChange={(e) => {
                      const currentSubCategoryIndex =
                        subCategoriesRes?.data.findIndex(
                          (elm) => elm.description === e
                        );
                      if (
                        currentSubCategoryIndex !== -1 &&
                        currentSubCategoryIndex !== undefined
                      ) {
                        const subCategory =
                          subCategoriesRes.data[currentSubCategoryIndex];

                        if (subCategory.vaultAccessRequired) {
                          form.setValue("vaultAccessRequired", "Yes");
                        } else {
                          form.setValue("vaultAccessRequired", "No");
                        }
                      }
                    }}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Area"
                    name="area"
                    isRequired
                    placeholder="Select Area"
                    data={Area}
                    text="text"
                    id="value"
                    rules={verificationRules.area}
                  />

                  <FormInput
                    {...generalProps}
                    label="Assignment Group"
                    name="assignmentGroup"
                    inputProps={{ readOnly: true }}
                  />

                  {/* <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="correlationId"
                    label="Correlation Id"
                    // rules={verificationRules.correlationId}
                  /> */}
                  {/* {form.watch("customerId") === "66e42d5af405de06de469b79" ? (
                    <FormInput
                      {...generalProps}
                      // isRequired={true}
                      name="secondaryAssigneeId"
                      label="Secondary Assignee Id"
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Accordion type="multiple" collapsible className="w-full">
                  <AccordionItem value="externalAgencies" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        Vehicle Breakdown
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormDropdown
                          {...generalProps}
                          label="Driver Name"
                          name="driverUserId"
                          placeholder="Select Driver"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormField
                          control={generalProps.control}
                          name="emailTime"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Email Time" />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    disabled={true}
                                    variant="secondary"
                                    className="px-3 py-2 border border-secondary rounded-md "
                                    value={field.value}
                                    placeholder="Select Date"
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                </div>
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormDropdown
                          {...generalProps}
                          label="Guard Name"
                          name="guardUserId"
                          placeholder="Select Guard"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormField
                          control={generalProps.control}
                          name="timeOfAlarm"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Time of Alarm" />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    variant="secondary"
                                    className="px-3 py-2 border border-secondary rounded-md "
                                    value={field.value}
                                    placeholder="Select Date"
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                </div>
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormDropdown
                          {...generalProps}
                          label="CTL Name"
                          name="ctlUserId"
                          placeholder="Select Employee"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormField
                          control={generalProps.control}
                          name="timeOfContactWithTeam"
                          rules={{ required: "Please Select Value" }}
                          render={({ field }) => (
                            <FormItem>
                              <Label
                                label="Time of contact with team"
                                isRequired
                              />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    variant="secondary"
                                    className="px-3 py-2 border border-secondary rounded-md "
                                    value={field.value}
                                    placeholder="Select Date"
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                </div>
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormDropdown
                          {...generalProps}
                          label="Custodian Name"
                          name="custodianUserId"
                          placeholder="Select Employee"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormInput
                          {...generalProps}
                          label="Total Connect Time With Team"
                          name="totalConnectTimeWithTeam"
                          isRequired
                          rules={{
                            required: "Please Select Value",
                            pattern: {
                              value: /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/,
                              message:
                                "Time must be in HH:MM:SS (24-hour) format",
                            },
                          }}
                          hideIcons
                        />
                        <FormDropdown
                          {...generalProps}
                          label="Violator Name"
                          name="violatorUserId"
                          placeholder="Select Employee"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormField
                          control={generalProps.control}
                          name="vehicleTeamLeftTime"
                          disabled={true}
                          // rules={{ required: "Please Select Value" }}
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Vehicle-Team Left Time" />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    variant="secondary"
                                    className="px-3 py-2 border border-secondary rounded-md "
                                    value={field.value}
                                    disabled={true}
                                    placeholder="Select Date"
                                    // onChange={(e) => {
                                    //   field.onChange(e.target.value);
                                    // }}
                                  />
                                </div>
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormInput
                          {...generalProps}
                          label="Violation Type"
                          name="violationType"
                        />

                        <FormInput
                          {...generalProps}
                          disabled={true}
                          label="Vehicle Idle Time"
                          name="vehicleIdleTime"
                          // rules={{
                          //   required: "Please Select Value",
                          //   pattern: {
                          //     value: /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/,
                          //     message:
                          //       "Time must be in HH:MM:SS (24-hour) format",
                          //   },
                          // }}
                          hideIcons
                        />

                        <FormDropdown
                          {...generalProps}
                          label="Sick Staff"
                          name="sickStaffUserId"
                          placeholder="Select Employee"
                          data={
                            usersListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.employeeId}-${elm.name}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                        />
                        <FormInput
                          {...generalProps}
                          label="Sickness Type"
                          name="sicknessType"
                          hideIcons
                        />
                        <FormInput
                          {...generalProps}
                          name="incidentLocation"
                          label="Location"
                          placeholder="Enter Incident Location"
                          isRequired
                          rules={verificationRules.incidentLocation}
                        />
                        <FormSelect
                          {...generalProps}
                          name="isIncidentReport"
                          label="Incident Report"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="text"
                          text="text"
                          hideIcons
                        />
                        <FormDropdown
                          {...generalProps}
                          label="Department"
                          name="businessUnitId"
                          placeholder="Select Department"
                          data={businessUnitRes?.data || []}
                          text="name"
                          id="id"
                        />
                        <FormSelect
                          {...generalProps}
                          name="isWorkOrder"
                          label="is Work Order"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="text"
                          text="text"
                          hideIcons
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="attachments" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        Attachments (Optional)
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        {uploadedImages?.map((elm, index) => (
                          <div
                            className="border border-solid-secondary relative w-[200px] h-[200px"
                            key={index}
                          >
                            <a
                              href={elm}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="] object-contain"
                                src={elm.filePath}
                                alt="preview"
                              />
                            </a>
                          </div>
                        ))}
                        {imagePreview?.map((elm, index) => (
                          <div
                            className="border border-solid-secondary relative w-[200px] h-[200px"
                            key={index}
                          >
                            <Button
                              className="absolute top-1 right-2 z-[1]"
                              variant="secondary"
                              type="button"
                              onClick={() => {
                                const attachments = imagePreview;

                                attachments.splice(index, 1);
                                form.setValue("attachments", attachments, {
                                  shouldDirty: true,
                                });
                                setImagePreview([...attachments]);
                              }}
                            >
                              <Trash />{" "}
                            </Button>{" "}
                            <a
                              href={elm}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="] object-contain"
                                src={elm}
                                alt="preview"
                              />
                            </a>
                          </div>
                        ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
